<div class="lum-modal invoice-shipping-rate-dialog__modal-wrapper">
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large"
      >Available Shipping Rates</span
    >
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="onClose()"
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Close
      </button>
    </div>
  </div>
  <div class="lum-modal__body">
    <div class="list-scroll-container">
      <mat-list class="shipping-rates__wrapper">
        <mat-list-item
          *ngFor="let rate of shippingRates"
          (click)="onRateSelect(rate)"
          class="rate-item"
        >
          <div class="rate">
            <div class="flex-column col-left">
              {{ rate.carrierName ?? '' }} - {{ rate.serviceName }}
            </div>
            <div class="flex-column col-right">
              {{ rate.shippingRateAmount | currency }}
            </div>
          </div>
          <mat-divider></mat-divider>
        </mat-list-item>
      </mat-list>
    </div>
  </div>
</div>
